//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import noticeVaribaleDialog from '../../components/noticeVaribaleDialog.vue';
export default {
  name: '',
  components: {
    noticeVaribaleDialog,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      serviceAcountList: [],
      serviceTemplateList: [],
      templateInfo: [],
      params: {},
      dialogVisible: false,
      protocolSelect: 'http://',
      urlPath: '',
      varType: '', // var title content
      varDiaShow: false,
    };
  },
  computed: {
    variableText() {
      if (this.varType === 'var') {
        return this.value.metadata.to[0] || '';
      }
      return '';
    },
    templateTitle() {
      return (
        this.serviceTemplateList.find((template) => template.id === this.value.metadata.template_id)
          ?.title || ''
      );
    },
    templateParams() {
      return (
        this.serviceTemplateList.find((template) => template.id === this.value.metadata.template_id)
          ?.fields || {}
      );
    },
  },
  watch: {
    params: {
      handler(newVal) {
        if (typeof newVal === 'object') {
          this.valueUpdate('metadata.params', JSON.stringify(newVal));
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.value.metadata.params && typeof this.value.metadata.params === 'string') {
      this.params = JSON.parse(this.value.metadata.params);
    }
    this.getServiceAcountList();
    if (this.value.metadata.app_id) {
      this.getOfficialAccountTemplateList(this.value.metadata.app_id);
    }
    const protocolReg = /(http|https):\/\//gi;
    const matchRes = (this.value.metadata?.jump_url || '').match(protocolReg);
    if (matchRes) {
      this.protocolSelect = matchRes[0];
      this.urlPath = this.value.metadata?.jump_url.replace(matchRes[0], '');
    } else {
      this.urlPath = this.value.metadata?.jump_url;
    }
  },
  methods: {
    openVariantDia() {
      this.varType = 'var';
      this.varDiaShow = true;
    },
    insertVariable(e) {
      switch (this.varType) {
        case 'var':
          this.valueUpdate('metadata.to', [e]);
          return;
      }
    },
    valueUpdate(path, value) {
      this.$emit('update', path, value);
    },
    getServiceAcountList() {
      this.$request({
        url: this.$api.getWxAppList,
        data: {
          page: 1,
          page_size: 99999,
        },
        cb: ({ data }) => {
          this.serviceAcountList = data.filter((item) => item.type === 2);
        },
      });
    },
    getOfficialAccountTemplateList(app_id) {
      this.$request({
        url: this.$api.GetOfficialAccountTemplateList,
        data: {
          app_id,
        },
        cb: ({ templates }) => {
          this.serviceTemplateList = templates;
        },
      });
    },
    serviceAccountChange(e) {
      this.valueUpdate('metadata.app_id', e);
      this.valueUpdate('metadata.template_id', '');
      // 查找 templateInfo 1. 设置 serviceTemplateList 2. 清空Params
      // this.serviceTemplateList = [];
      this.params = {};
      this.getOfficialAccountTemplateList(e);
    },
    accountTemplateChange(e) {
      this.valueUpdate('metadata.template_id', e);

      // 根据选择的模版 从新设置 模版列表
      const fields = this.serviceTemplateList.find((template) => template.id === e)?.fields || {};
      const params = {};
      for (const key in fields) {
        params[key] = { value: '', color: '#173177' };
      }
      this.params = params;
    },
    jumpConifgChange(e) {
      this.valueUpdate('metadata.link_type', e);
      // 数据重置
      this.protocolSelect = 'http://';
      this.urlPath = '';
      this.valueUpdate('metadata.mp_app_id', '');
      this.valueUpdate('metadata.jump_url', '');
    },
    updateUrlLinkInputUrl(e) {
      if (e) {
        this.valueUpdate('metadata.jump_url', this.protocolSelect + e);
      } else {
        this.valueUpdate('metadata.jump_url', '');
      }
    },
    updateUrlLinkPrototaSelect(e) {
      if (this.urlPath) {
        this.valueUpdate('metadata.jump_url', e + this.urlPath);
      } else {
        this.valueUpdate('metadata.jump_url', '');
      }
    },
    disturbEnbaleChange(e) {
      if (!e) {
        this.valueUpdate('metadata.setting.disturb.from', '');
        this.valueUpdate('metadata.setting.disturb.to', '');
      } else {
        this.valueUpdate('metadata.setting.disturb.from', '22:00');
        this.valueUpdate('metadata.setting.disturb.to', '07:00');
      }

      this.valueUpdate('metadata.setting.disturb_enbaled', e);
    },
    diaBeforeClose() {
      this.dialogVisible = false;
    },
  },
};
